module.exports = __webpack_public_path__ + "media/question10_au.7ac2246c.mp3";